import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { Drawer, Input } from "components";
import { useGetNinjaOneOAuthAuthorization } from "controller";
import React from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { addMixpanelEvent } from "utilz/helpers";
import * as yup from "yup";

const shema = yup.object({
  url: yup.string().required("URL is required").url("Please enter a valid URL"),
});

interface ninjaDrawerProps {
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
  // setAdHocItemsData: React.Dispatch<React.SetStateAction<never[]>>;
}
function NinjaOneConnectionDrawer({ open, onOpen, onClose }: ninjaDrawerProps) {
  const { mutateAsync: NinjaOneOauth, isLoading: isNinjaOauthLoading } =
    useGetNinjaOneOAuthAuthorization();
  const theme = useTheme();

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      url: "https://app.ninjarmm.com",
    },
    resolver: yupResolver(shema),
  });

  const connectToNinjaOne = handleSubmit(async (data: { url: string }) => {
    try {
      const oAuthLink = await NinjaOneOauth({
        url: data.url,
        frontendUrl: window.location.origin,
      });

      if (oAuthLink) {
        addMixpanelEvent({
          event: "ninja_one_connection_success",
        });
        window.location.href = oAuthLink;
        onClose();
      } else {
        toast.error("Invalid URL");
      }
    } catch (error: any) {
      toast.error(error.message);
      console.log(error);
    }
  });

  return (
    <Box sx={{ width: "400px" }}>
      <Drawer
        title={"Connect NinjaOne RMM"}
        onClose={onClose}
        onOpen={onOpen}
        open={open}
        headerTitleStyleSx={{
          textTransform: "none",
        }}
        // open={true}
        primaryButtonText="Proceed"
        secondaryButtonText="Cancel"
        onPrimaryButtonClick={() => {
          connectToNinjaOne();
        }}
        onSecondaryButtonClick={() => {
          onClose();
        }}
        isLoading={isNinjaOauthLoading}
      >
        <Stack gap={"32px"} sx={{ p: "24px" }}>
          <Stack gap={"16px"}>
            <Stack gap={"8px"}>
              <Typography
                variant="button-small"
                color={theme.palette.lightBg.high}
              >
                1 . Locate the Link
              </Typography>
              <Typography
                variant="body-small"
                color={theme.palette.lightBg.low}
              >
                Find the link above your NinjaOne's login page & Copy it.
              </Typography>
            </Stack>

            <Stack gap={"8px"}>
              <Typography
                variant="button-small"
                color={theme.palette.lightBg.high}
              >
                2 . Paste the Link
              </Typography>
              <Typography
                variant="body-small"
                color={theme.palette.lightBg.low}
              >
                Click on the textbox below & paste it
              </Typography>
            </Stack>

            <Stack gap={"8px"}>
              <Typography
                variant="button-small"
                color={theme.palette.lightBg.high}
              >
                3 . Connect
              </Typography>
              <Typography
                variant="body-small"
                color={theme.palette.lightBg.low}
              >
                Click on "Proceed" to Connect.
              </Typography>
            </Stack>
          </Stack>
          <Stack gap={"16px"}>
            <Typography variant="body-small" color={theme.palette.lightBg.low}>
              Copy the URL from NinjaOne's address bar as mentioned above.
            </Typography>
            <Input
              name="url"
              control={control}
              label="URL"
              placeholder="eg : https://app.ninjarmm.com"
              value={""}
              disabled={false}
              error={errors.url ? true : false}
              errorMessage={errors.url?.message}
            />
          </Stack>
        </Stack>
      </Drawer>
    </Box>
  );
}

export default NinjaOneConnectionDrawer;
